(function () {
  'use strict';

  /* @ngdoc object
   * @name events.view
   * @description
   *
   */
  angular
    .module('events.view', [
      'ui.router'
    ]);
}());
